import React from "react";
import {Event} from "../../../../cp/components/Comet";
import {removeDuplicates} from "../../helpers/remove-duplicates";
import {useEventContext} from "../EventContext";

export default () => {
    const {eventDispatch} = useEventContext();

    function onCreateEpisode(data) {
        eventDispatch((event) => ({
            ...event,
            stream: event.stream.map((item) => {
                return item.id === data.streamId
                    ? {...item, episode: removeDuplicates([...item.episode, data], 'id')}
                    : item;
            })
        }));
    }
    function onUpdateEpisode(data) {
        eventDispatch((event) => ({
            ...event,
            stream: event.stream.map((item) => {
                return item.id === data.streamId
                    ? {...item, episode: removeDuplicates(item.episode.map((ep) => ep.id === data.id ? {...ep, ...data} : ep), 'id')}
                    : item;
            })
        }));
    }
    function onDeleteEpisode(data) {
        eventDispatch((event) => ({
            ...event,
            stream: event.stream.map((item) => {
                return {...item, episode: item.episode.filter(({id}) => id !== data.id)}
            })

        }));
    }

    return (
        <>
            <Event event="create:episode" handler={(data) => onCreateEpisode(data)} />
            <Event event="update:episode" handler={(data) => onUpdateEpisode(data)} />
            <Event event="update:episode/like" handler={(data) => onUpdateEpisode(data)} />
            <Event event="delete:episode" handler={(data) => onDeleteEpisode(data)} />
        </>
    );
}
